





























































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";
import { msToVariableTime } from ".";
import { TreatmentMonitoringApi, UnitModel, VariableDataModel } from "../../../apis";
@Component({
  components: {},
})
export default class StatusParam extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop({ default: () => {} }) unit: UnitModel;

  variables: any[] = [];
  variablesOrginal: VariableDataModel[] = [];

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }

  get HEADERS() {
    return [
      {
        text: this.$t("text.status"),
        value: "variable.variableName",
        cellClass: [],
      },
      {
        text: this.$t("text.value"),
        value: "value",
        // cellClass: ["tw-p-0"],
      },
    ] as DataTableHeader[];
  }

  get BOOL_VALUES() {
    return [
      { text: "ON", value: 1 },
      { text: "OFF", value: 0 },
    ];
  }

  async onShow() {
    await this.getStatusParams();
  }

  async getStatusParams() {
    this.$util.showLoading();
    try {
      const { id: unitId } = this.$route.params;
      const rs =
        await new TreatmentMonitoringApi().getVariableDatasByUnitIdTabName({
          unitId,
          tabName: "STATUS",
        });
      this.variables = rs.data.data.map((val) => {
        if (val.variable.type === "TIME" && val.value != null) {
          const value = msToVariableTime(val.value / 1000);
          return { ...val, value };
        }
        return val;
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  // async doSave() {
  //   this.$util.showLoading();
  //   try {
  //     await new TreatmentMonitoringApi().submitVariableData({
  //       postSubmitVariableDataRequest: {
  //         // variableDatas: this.variables,
  //         locationId: this.unit.location.id,
  //         writeData: []
  //       },
  //     });
  //     this.show = false;
  //   } catch (error) {
  //     this.$util.showError(error);
  //   } finally {
  //     this.$util.hideLoading();
  //   }
  // }
}
